import { render, staticRenderFns } from "./process_route_list.vue?vue&type=template&id=141ba180&scoped=true"
import script from "./process_route_list.vue?vue&type=script&lang=js"
export * from "./process_route_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141ba180",
  null
  
)

export default component.exports